import { FactoryProvider, InjectionToken } from '@angular/core';
import { WINDOW } from '../core/providers/window.providers';
import { PageViewParams } from './gtag.interfaces';

export const GA_MEASUREMENT_ID = new InjectionToken('gtagId');
export const GTAG = new InjectionToken('gtagToken');

type GtagFunc = (...args: any) => void;

declare global {
    interface Window {
        gtag: GtagFunc;
    }
}

export class Gtag {
    constructor(private gtag: GtagFunc) { }

    pageView(gaMeasurementId: string, params: PageViewParams): void {
        this.gtag('config', gaMeasurementId, params)
    }
}

export function gtagFactory(window: Window) {
    if (typeof window.gtag === "function") {
        return new Gtag(window.gtag);
    }
    else {
        return null;
    }
}

export const gtagProvider: FactoryProvider = {
    provide: GTAG,
    useFactory: gtagFactory,
    deps: [WINDOW]
};

export const ANALYTICS_PROVIDERS = [
    gtagProvider
];
